import * as React from "react";

import { FocusManagementObserver } from "../../Services/FocusManagement/FocusManagementObserver";

export interface FiasStringAddressProps {
    stringAddress: string;
    onRequestFocus: () => void;
}

export const FiasStringAddress = (props: FiasStringAddressProps): JSX.Element => (
    <FocusManagementObserver onRequestFocus={props.onRequestFocus}>
        <span>{props.stringAddress}</span>
    </FocusManagementObserver>
);
